import {Button} from 'antd';
import {Input} from 'antd/es';
import Form from 'antd/es/form';
import {useForm} from 'antd/es/form/Form';
import React, {useEffect, useState} from 'react';

import {ActionBar} from 'components/@common/widgets/action-bar';
import {AIS_ROUTES} from 'components/ais/ais.constants';
import {ModalOpenerComponent} from 'components/modal-opener-component';
import {TTaxForecastFiltersData} from 'pages/ais/submit-income-tax-forecast';
import {getTaxForecastDataByRequestId, sendTaxForecast} from 'pages/ais/submit-income-tax-forecast/api/thunks';
import {selectTaxForecastsFiltersData} from 'pages/ais/submit-income-tax-forecast/model/slice';
import {useUserRoleFunctions} from 'shared/hooks/use-user-role-functions';
import {showMessage} from 'shared/utils/notifications';
import {showRequestErrorMessage} from 'shared/utils/show-message-from-response';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';
import {EUserRoleFunction} from 'store/slices/user-slice/user-slice-role-functions';

export const TaxForecastActionPanel = () => {
    const dispatch = useAppDispatch();
    const {requestId, status} = useAppSelector(selectTaxForecastsFiltersData) ?? {};
    const [form] = useForm<Pick<TTaxForecastFiltersData, 'requestId'>>();
    const {hasUserRoleFunction} = useUserRoleFunctions({
        sections: [AIS_ROUTES.TAX_FORECAST],
    });
    const isSendResponseButtonHidden = !(!status && hasUserRoleFunction(EUserRoleFunction.CREATE));

    const [isOpen, setOpen] = useState(false);

    useEffect(() => {
        form.resetFields();
    }, [requestId]);

    const handleFinish = () => {
        if (!requestId) {
            console.error('requestId не найден, сохранение невозможно');
            return;
        }

        dispatch(sendTaxForecast({requestId}))
            .unwrap()
            .then(data => {
                showMessage({message: data});
                dispatch(getTaxForecastDataByRequestId({requestId}));
                setOpen(false);
            })
            .catch(e => showRequestErrorMessage(e));
    };

    return (
        <ActionBar
            side="left"
            transparent
        >
            <ModalOpenerComponent
                isOpen={isOpen}
                setIsOpen={setOpen}
                component={(
                    <Button
                        type="primary"
                        disabled={!requestId}
                        hidden={isSendResponseButtonHidden}
                    >Отправить ответ
                    </Button>
                )}
                modalProps={{
                    title: 'Комментарий ФНС',
                    centered: true,
                    width: '780px',
                }}
                handleSave={() => {
                    form.submit();
                }}
                controlLabels={{
                    save: 'Отправить',
                    cancel: 'Закрыть',
                }}
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleFinish}
                >
                    <Form.Item
                        name="name"
                        label="Наименование сервиса"
                        initialValue="Сервис отправки ответа с прогнозом налоговой
                         базы и суммы налога на прибыль организаций v3"
                    >
                        <Input
                            disabled
                        />
                    </Form.Item>
                    <Form.Item
                        name="requestId"
                        label="Номер запроса"
                        initialValue={requestId}
                    >
                        <Input disabled />
                    </Form.Item>
                </Form>
            </ModalOpenerComponent>
        </ActionBar>
    );
};
